import Constants from './constants'
import { Buffer } from 'buffer'

const TagTypes = Constants.TagTypes
const hex2dec = require('./hex2dec')
const utils = require('./utils')

function parseInteger (value) {
  if ((value[0] & 80) === 1) {
    throw new Error('No support for 2s complement number yet')
  } else {
    const hex = Buffer.from(value).toString('hex')
    return hex2dec.hexToDec(hex)
  }
}

function isLeadingBitSet (byte) {
  return (byte & 0x80) === 0x80
}

function hexByteToDecimal (byte) {
  const hex = byte.toString(16)
  const decimal = hex2dec.hexToDec(hex)
  return decimal
}

function parsePrintableString (value) {
  return value.toString()
}

function parseIA5String (value) {
  return value.toString()
}

function shiftToLeadingBits (byte, num) {
  let byteCopy = byte
  let newByte = 0x00
  for (let i = 0; i < num; i++) {
    newByte = newByte >> 1
    // If the LSB bit is 1, set the leading bit
    if ((byteCopy & 0x01) === 0x01) {
      newByte = newByte | 0x80
    }

    // Shfit the byte to analyze the next
    byteCopy = byteCopy >> 1
  }
  return newByte
}

function getLeadingAndZeroBits (bytes) {
  let leadingBits = []
  bytes.slice(0, -1).map((b, index) => {
    // Keep the right n bits
    const n = bytes.length - index - 1
    const contextualMask = shiftToLeadingBits(b, n)
    leadingBits.push([contextualMask, 0xff >> n])
  })
  leadingBits.push([0x00, 0xff])
  leadingBits = leadingBits.reverse()

  return leadingBits
}

function getObjectIdentifierLen (bytes, offset) {
  let len = 1
  while (isLeadingBitSet(bytes.readUInt8(offset + len))) {
    // && (offset + len) <= value.length) {
    len = len + 1
  }
  len = len + 1
  return len
}

function parseObjectIdentifier (value) {
  const headNumber = hexByteToDecimal(value.readUInt8(0))
  const parsedHead = [
    Math.trunc(+headNumber / 40), // remove decimal
    +headNumber % 40
  ]

  let offset = 1
  const parsedTail = []
  while (offset < value.length) {
    const b = value.readUInt8(offset)
    if (isLeadingBitSet(b)) {
      const len = getObjectIdentifierLen(value, offset)
      if (offset + len > value.length) {
        throw new Error('Malformed object identifier.')
      }
      const idBytes = value.slice(offset, offset + len)
      const masks = getLeadingAndZeroBits(idBytes)
      const parsedBytes = idBytes.map((b, index) => {
        let tmpByte = b
        const [maskWithBits, maskWithZeros] = masks[index]
        const hasLeadingBit = isLeadingBitSet(tmpByte)
        tmpByte = tmpByte & 0x7f
        tmpByte = tmpByte & maskWithZeros
        if (hasLeadingBit) {
          tmpByte = tmpByte >>> (idBytes.length - 1 - index)
        }
        tmpByte = tmpByte | maskWithBits
        return tmpByte
      })
      const hex = Buffer.from(parsedBytes).toString('hex')
      const dec = hex2dec.hexToDec(hex)
      parsedTail.push(dec)
      offset = offset + len
    } else {
      parsedTail.push(hexByteToDecimal(b))
      offset = offset + 1
    }
  }
  // @ts-ignore
  const result = parsedHead.concat(parsedTail).join('.')
  return result
}

function parseBoolean (bytes) {
  const T = 0xff
  const F = 0x00
  if (bytes.length != 1 || ![T, F].includes(bytes[0])) {
    throw new Error('Malformed boolean')
  }
  return bytes[0] === T
}

function parseBitString (bytes) {
  const unusedBits = bytes.readUInt8(0)
  if (unusedBits == 0x00) {
    const hex = []
    bytes.slice(1).forEach((b) => hex.push(('0' + b.toString(16)).slice(-2)))
    return {
      hex: hex.join(':')
    }
  } else {
    throw new Error('TODO: Handle unsued bits for bit string')
  }
}

function parseOctetString (bytes) {
  return {
    hex: utils.bytesToHex(bytes)
  }
}

function parseUtcTime (bytes) {
  const dateString = bytes.toString()
  const yearDigits = dateString.substring(0, 2)
  const month = dateString.substring(2, 4)
  const day = dateString.substring(4, 6)
  const hour = dateString.substring(6, 8)
  const min = dateString.substring(8, 10)
  const sec = dateString.substring(10, 12)
  let year
  if (yearDigits >= 50) {
    year = `19${yearDigits}`
  } else {
    year = `20${yearDigits}`
  }

  const d = new Date()
  d.setUTCFullYear(+year)
  d.setUTCMonth(month - 1) // Javascript quirk, month is the only one that is zero indexed
  d.setUTCDate(day)
  d.setUTCHours(hour)
  d.setUTCMinutes(min)
  d.setUTCSeconds(sec)
  d.setUTCMilliseconds(0)

  return d
}

function parseGeneralizedTime (bytes) {
  throw new Error('Token type GeneralizedTime not supported')
}

function parseUtf8String (bytes) {
  return bytes.toString()
}

function parseSequence (bytes) {
  console.log('[+] !!! hERE !!!')

  return []
}
function parseSet (bytes) {
  return []
}

function parseNull (bytes) {
  return null
}

const tagToParseFunctionMap = {
  PRINTABLESTRING: parsePrintableString,
  INTEGER: parseInteger,
  OBJECT: parseObjectIdentifier,
  BITSTRING: parseBitString,
  OCTETSTRING: parseOctetString,
  UTCTIME: parseUtcTime,
  GENERALIZEDTCTIME: parseGeneralizedTime,
  UTF8STRING: parseUtf8String,
  IA5STRING: parseIA5String,
  SEQUENCE: parseSequence,
  SET: parseSet,
  NULL: parseNull,
  BOOLEAN: parseBoolean
}

function getParsingFunction (tagString) {
  return tagToParseFunctionMap[tagString]
}

function parse (tlv) {
  const tagStr = Constants.tag_to_type(tlv.tag)
  const tagType = Constants.getTagType(tlv.tag)
  switch (tagType) {
          case TagTypes.Universal: {
            const parsingFunc = getParsingFunction(tagStr)
            if (parsingFunc === undefined) {
              throw new Error(`No parsing function for ${tagStr} ${tlv.tag.toString(16)}`)
            }
            const parsedResult = parsingFunc(tlv.value)
            return parsedResult
          }    case TagTypes.Application:
      throw new Error('err')
    case TagTypes.ContextSpecific:
      throw new Error('err')
    case TagTypes.Private:
      throw new Error('err')
  }
}

export default {
  shiftToLeadingBits,
  getLeadingAndZeroBits,
  parseObjectIdentifier,
  parseInteger,
  parsePrintableString,
  parseIA5String,
  parseBoolean,
  parseBitString,
  parseOctetString,
  parseUtcTime,
  parseGeneralizedTime,
  parseUtf8String,
  parse
}
